import { makeStyles } from '@mui/styles';

const useCustomSelectStyles = makeStyles((theme) => ({
    inputLabel: {
        fontFamily: 'Rubik, sans-serif',
        fontSize: '14px',
        fontWeight: 500,
        lineHeight: '20px',
        textAlign: 'left',
        color: '#1d2939',
    },

    placeholderItem: {
        display: 'none',
    },

    selectContainer: {
        width: '100%',
        borderRadius: '8px',
        fontFamily: 'var(--font-rubik)',

        '& .MuiSelect-select.MuiSelect-outlined': {
            padding: '10px 40px 10px 14px',
        },

        '& .Mui-disabled': {
            backgroundColor: '#F3F4F6',
            borderColor: '#DDDDDD',
            opacity: 0.5,
        },

        '& .MuiOutlinedInput-notchedOutline': {
            border: '1px solid #E5E7EB',
        },

        '&.Mui-error .MuiOutlinedInput-root': {
            borderColor: '#EF4444',
        },

        '& .MuiOutlinedInput-root.MuiSelect-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#1BA1DB',
        },

        '&:hover:not(.Mui-disabled) .MuiOutlinedInput-notchedOutline': {
            border: '1px solid #1BA1DB',
        },

        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            border: '1px solid #1BA1DB',
        },

        '& .MuiSelect-nativeInput': {
            fontFamily: 'var(--font-rubik)',
            fontSize: '16px',
            fontWeight: 400,
            lineHeight: '20px',
            color: '#101828',
        },

        '&::placeholder': {
            fontFamily: 'var(--font-rubik)',
            fontSize: '16px',
            fontWeight: 400,
            lineHeight: '20px',
            color: '#98A2B3',
        },

        '& .MuiSelect-icon': {
            '& path': {
                fill: '#dddddd',
            },
            top: '40%',
            right: '14px',
        },
    },
    menuStyles: {
        '&::-webkit-scrollbar': {
            width: '6px',
            backgroundColor: '#d9d9d9',
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#8c8c8c',
            borderRadius: '4px',
        },
    },

    menuItem: {
        '&.MuiMenuItem-root': {
            padding: '10px 12px',
            fontFamily: 'Rubik, sans-serif',
            fontSize: '14px',
            fontWeight: 400,
            lineHeight: '20px',
            textAlign: 'left',
            color: '#262626',
            display: 'block',
        },
    },

    tooltipMenuItem: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        pointerEvents: 'none',
        color: '#DDDDDD !important',

        '& .MuiIconButton-root': {
            pointerEvents: 'auto',
            color: '#344054',
        },
    },
    errMsg: {
        fontFamily: 'Rubik, sans-serif',
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '20px',
        textAlign: 'left',
        color: '#D92D20',
        marginTop: '6px',
    },
}));

export default useCustomSelectStyles;
